import Menu from './components'

export default Menu


// WEBPACK FOOTER //
// ./src/App/components/Menu/index.js